export default __webpack_public_path__ + "static/media/add-program.f4f7724b.svg";